import axios from 'axios';
import { GatewayV2Types } from '../../services/gatewayV2/gatewayV2.types';

export class GatewayV2Provider {
    constructor(protected path: string) {}

    get prefix() {
        return `${this.path}/gw2`;
    }

    public preApprovalsSearch = async (data: Pick<GatewayV2Types.PreApprovalsSearchRequest, 'locationRoute'>) => {
        try {
            await axios.post<void>(`${this.prefix}/pre-approvals-search/`, data, {
                withCredentials: true,
            });
        } catch (e) {
            return null;
        }
    };

    public getStatusesV2 = async () => {
        const { data } = await axios.get<GatewayV2Types.StatusesV2Response>(`${this.prefix}/statuses-v2/`, {
            withCredentials: true,
        });
        return data;
    };
}
